import React from "react";
import useFormattedResponse from "../../../hooks/useFormattedResponse";
import "./ServerResponse.css";

const ServerResponse = ({rawResponse}) => {
  const formattedResponse = useFormattedResponse(rawResponse);

  if (!formattedResponse) {
    return <p>Нет данных для отображения</p>;
  }

  const {objectsList, qualityParameters, recommendations} = formattedResponse;
  /* fix:  */
  return (
    <div className="server-response">
      <h2>Результаты анализа</h2>
      <p>
        <strong>Объекты:</strong> {objectsList}
      </p>

      <div className="section">
        <h3>Параметры качества</h3>
        <ul>
          {qualityParameters &&
            Object.entries(qualityParameters).map(([key, value]) => (
              <li key={key}>
                <strong>{key}:</strong> {String(value)}
              </li>
            ))}
        </ul>
      </div>

      {recommendations && Object.keys(recommendations).length > 0 && (
        <div className="section">
          <h3>Рекомендации</h3>
          <ul>
            {Object.entries(recommendations).map(([key, value]) => (
              <li key={key}>
                <strong>{key}.</strong> {value}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ServerResponse;
